var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('Card',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header text-center p-4 "},[_c('h1',[_vm._v("List All Product")])])}]

export { render, staticRenderFns }